import { AGE_BAND_VARIABLE, AGE_BANDS } from '@components/storeMap/dataAge'
import useTypedTranslation from '@hooks/useTypedTranslation'

export function DataAgeLegend() {
  const { t } = useTypedTranslation()

  return (
    <div
      data-testid='data-age-legend'
      className={`
        absolute right-0 bottom-0 flex flex-col gap-1 rounded-sm border border-border-primary bg-bg-tertiary p-4 text-sm
        opacity-100 transition-all duration-500
        starting:opacity-0
      `}>
      <p className='font-medium'>{t('storeMap.layers.legendDataAge.title')}</p>
      {AGE_BANDS.map(band => (
        <div key={band} className='flex items-center gap-2 text-text-secondary'>
          <span className='size-3 rounded-xs border border-shelf-border' style={{ background: `var(${AGE_BAND_VARIABLE[band]})` }} />
          {t(`storeMap.layers.legendDataAge.${band}`)}
        </div>
      ))}
      <div className='flex items-center gap-2 text-text-secondary'>
        <span className='size-3 rounded-xs border border-dashed border-shelf-border' />
        {t('storeMap.layers.legendDataAge.noData')}
      </div>
    </div>
  )
}
